import { useCallback, useEffect, useState } from "react";
import { domain, token } from "../../components/Security";
import axios from "../.../../../api/apiClient";
import { Select } from "../Select"; 

export function RequirementCategorySelect({
  label = "Requirement Category",
  value,
  onChange,
  setValue,
  isRequired = false,
  isDisabled = false,
  isEditMode = false,
  placeholder = "Choose Category",
  className = "",
  parentClassName = "",
  error = false,
  errorMessage = "",
  includeInactive = false,
  ...props
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(domain + "/api/RequirementCategory", {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = response.data || [];

      const transformedOptions = data
        .filter(cat => includeInactive || cat.isActive)
        .map(cat => ({
          value: cat.id.toString(),
          label: cat.isActive ? cat.description : `${cat.description} [Inactive]`,
          rawData: cat
        }));

      setOptions(transformedOptions);
    } catch (err) {
      console.error('Error fetching requirement categories:', err);
    } finally {
      setLoading(false);
    }
  }, [includeInactive]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleChange = (e) => {
    /* MODIFIED: Extract the value from the event first */
    const selectedValue = e.target.value;
    
    if (onChange) {
      // If the parent passed a standard handler
      onChange(e);
    } else if (setValue) {
      // If the parent passed a direct state setter (like setSelectedCategory)
      setValue(selectedValue);
    }
  };

  return (
    <Select
      label={label}
      isRequired={isRequired}
      isDisabled={isDisabled || loading}
      isEditMode={isEditMode}
      value={value?.toString() || ""}
      onChange={handleChange}
      options={options}
      placeholder={loading ? "Loading categories..." : placeholder}
      className={className}
      parentClassName={parentClassName}
      error={error}
      errorMessage={errorMessage}
      {...props}
    />
  );
}